import { Img } from '~/components/elements/Img'

export const FolderImages: React.FC<{
  folderImageUrls: string[]
  imagePriority?: boolean
}> = ({ folderImageUrls, imagePriority }) => {
  return (
    <div className="grid aspect-[19/17] grid-cols-3 grid-rows-2 gap-[1px] xl:aspect-[315/278]">
      {[...Array(6)].map((_, index) => {
        const imageUrl = folderImageUrls[index]
        const className =
          'first:rounded-tl [&:nth-child(3)]:rounded-tr [&:nth-child(4)]:rounded-bl last:rounded-br'
        if (!imageUrl)
          return (
            <div
              className={`bg-gray-50 xl:bg-gray-200 ${className}`}
              key={index}
            />
          )

        return (
          <div className={`${className} relative overflow-hidden`} key={index}>
            <Img
              src={imageUrl}
              alt=""
              fill
              sizes="100vw"
              className="object-cover"
              priority={imagePriority}
            />
          </div>
        )
      })}
    </div>
  )
}
